import axios from "axios";
import { baseURL } from "../globals/constants";
import { showErrorToast } from "../utils/Toast";

const headers = () => ({ headers: { Accept: "application/json", Authorization: `Bearer ${localStorage.getItem("access_token")}` } });

/**
 * Gratis dage til en kunde. Serveren flytter den næste betaling i Stripe, så kunden ikke bliver trukket
 * før den nye dato, og skriver i revisionsloggen hvem der gav hvad til hvem og hvorfor.
 *
 * Serveren svarer 428, hvis begrundelsen mangler. Det klarer supportMode: den spørger og gentager kaldet.
 */
export const giveFreeDays = async (
  userId: string,
  days: number
): Promise<{ days: number; nextPayment: string | null; freeUntil: string; movedInStripe: boolean } | null> => {
  try {
    return (await axios.post(`${baseURL}/v1/subscription/free-days/${userId}`, { days, reason: "" }, headers())).data;
  } catch (error: any) {
    showErrorToast(error?.response?.data?.message || "Dagene kunne ikke gives", false);
    return null;
  }
};
